import React, { useEffect } from "react";
import "./AboutUs.css";

export default function AboutUs() {
  useEffect(() => {
    document.title = "About | Gifted Child Therapy";
  }, []);

  return (
    <div className="about-page">
      {/* Page Heading */}
      <header className="about-header text-center">
        <div className="about-banner-wrapper">
          <img
            src="/aboutTitle.png"
            alt="About Us"
            className="about-banner-img"
          />
        </div>
        <p className="about-subtitle">
          Discover our vision, mission, leadership, and purpose
        </p>
      </header>

      {/* Vision */}
      <section className="section container my-5">
        <div className="section-img col-md-6">
          <img src="/vision.png" alt="Vision" />
        </div>
        <div className="section-content col-md-6">
          <h2 className="section-heading">Our Vision</h2>
          <p className="section-text">
            Every child is a gift from God and deserves to be celebrated,
            nurtured, and empowered to reach their fullest potential.
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="section container my-5 mission-section">
        <div className="section-content col-md-6 order-md-2">
          <h2 className="section-heading">Our Mission</h2>
          <p className="section-text">
            To provide compassionate, holistic, and evidence-based therapy
            services that empower children with diverse developmental needs,
            supporting their growth, independence, and meaningful participation
            in family, school, and community life.
          </p>
        </div>
        <div className="section-img col-md-6 order-md-1">
          <img src="/mission.png" alt="Mission" />
        </div>
      </section>

      {/* Founder */}
      <section className="founder-section container my-5">
        <h2 className="section-heading text-center mb-4">Founder’s Message</h2>

        <p className="founder-text">
          Welcome to <strong>The Gifted Child Pediatric Therapy Centre</strong>.
        </p>

        <p className="founder-text">
          Every child truly is a precious gift from God, unique in their talents, challenges, and potential. 
          I founded this centre with a heartfelt mission to create a place where children with special needs 
          feel valued, understood, and empowered to grow in all areas of their lives.
        </p>

        <p className="founder-text">
          Our clinic brings together a passionate team of therapists, educators, and psychologists who share a 
          common goal: to nurture each child's abilities through compassionate, evidence-based therapies tailored to their individual needs. 
          We believe in working closely with families, because we know that parents and caregivers are an essential part of every child's success story.
        </p>

        <p className="founder-text">
          At <span className="fw-semibold">The Gifted Child</span>, we strive to create a warm, welcoming environment where every child is 
          encouraged to explore, learn, and thrive, no matter its diagnosis or challenges. We celebrate every milestone, no matter how big or small, 
          and are committed to walking alongside you and your family every step of the way.
        </p>

        <p className="founder-text">
          Thank you for trusting us with your child's care. Together, we can unlock the incredible potential within every gifted child.
        </p>

        <p className="founder-name mt-3">With warmth and hope,</p>
        <p className="founder-name fw-semibold">Dr. Jabanal Preeti</p>
        <p className="founder-designation">Founder & Director</p>
      </section>

      {/* Director */}
      <section className="director-section container my-5">
        <div className="row align-items-center">
          <div className="col-md-5 director-image-wrapper">
            <img
              src="/directorPic1.png"
              alt="Dr. Jabanal Preeti – Pediatric Occupational Therapist"
              className="director-image"
            />
          </div>

          <div className="col-md-7 director-content">
            <h3 className="director-name">Dr. Jabanal Preeti</h3>
            <h5 className="director-title">Pediatric Occupational Therapist</h5>

            <p>
              Dr. Jabanal Preeti is a highly experienced{" "}
              <strong>Pediatric Occupational Therapist</strong> with
             over <strong>
                17 years of dedicated clinical practice
              </strong>{" "}
              supporting children with diverse developmental needs.
            </p>

            <p>
              She holds a{" "}
              <strong>Master’s degree in Pediatric Occupational Therapy</strong>{" "}
              and a
              <strong>
                {" "}
                Bachelor’s degree in Special Education (Intellectual Disability)
              </strong>
              . Her advanced certifications include{" "}
              <strong>Sensory Integration</strong>
              (University of Southern California),{" "}
              <strong>Therapeutic Listening Program (USA)</strong>,
              <strong> Rhythmic Movement Training</strong>, and{" "}
              <strong>Brain Gym</strong>.
            </p>

            <p>
              Her professional mission is rooted in the belief that{" "}
              <strong>
                every child deserves the opportunity to achieve their highest
                potential
              </strong>
              . She focuses on helping children reach{" "}
              <strong>developmental milestones</strong> and transition
              successfully into
              <strong>
                {" "}
                mainstream, inclusive, or special education settings
              </strong>{" "}
              based on individual needs.
            </p>

            <p>
              Dr. Preeti currently works as a consultant with{" "}
              <strong>Dr. Angela David</strong>, Developmental Pediatrician in
              Bangalore. Her expertise includes
              <strong> early intervention</strong>,{" "}
              <strong>sensory processing</strong>,
              <strong> fine motor development</strong>,{" "}
              <strong>school readiness</strong>,
              <strong> behavioural regulation</strong>, and{" "}
              <strong>parent training programs</strong>.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
